import { Injector } from "@angular/core";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { InstitutionService } from "../../../DataService/institution/institution.service";
import { UserStoreService } from "../../../store/user/user.store.service";
import { BalanceByAccountsSymbols } from "../../../../models/types/balanceGroupingTypes";
import { TransactionBalanceHelpers } from "../../transactionBalances/transactionBalanceHelpers";
import { AccountView } from "../../../../models/view/account/account.view";
import { DataPluginStoreService } from "@bitwarden/web-vault/app/services/store/data-plugin/data-plugin.store.service";
import { ScenarioStoreService } from "@bitwarden/web-vault/app/services/store/scenario/scenario.store.service";

export class ScenarioDataAggregator {
  private injector: Injector;
  private institutionService: InstitutionService;
  private dataPluginStoreService: DataPluginStoreService;
  private userStoreService: UserStoreService;
  private scenarioStoreService: ScenarioStoreService;
  protected i18nService: I18nService;

  constructor(injector: Injector) {
    this.injector = injector;
    this.institutionService = this.injector.get(InstitutionService);
    this.scenarioStoreService = this.injector.get(ScenarioStoreService);
    this.userStoreService = this.injector.get(UserStoreService);
    this.dataPluginStoreService = this.injector.get(DataPluginStoreService);
    this.i18nService = this.injector.get(I18nService);
  }

  async getAllScenarioAccounts(): Promise<AccountView[]> {
    const accountViews = this.userStoreService.enrichAccounts.collection();
    return accountViews.filter((acc) =>
      this.scenarioStoreService.filters.selected().accounts.includes(acc.id),
    );
  }

  async getInstitutionsMasterList() {
    return await this.institutionService.getInstitutionsMasterList();
  }

  async getBookById(id: string): Promise<AccountView> {
    return this.scenarioStoreService.filteredAccounts
      .collection()
      .find((account) => account.id === id);
  }

  async createStartingTransactionsFromBalance(startDate: Date, balances: BalanceByAccountsSymbols) {
    const transactionBalanceHelpers = new TransactionBalanceHelpers();
    return await transactionBalanceHelpers.createStartingTransactionsFromBalance(
      startDate,
      balances,
      this.userStoreService,
      this.i18nService.t("startingBalanceTodayFor"),
    );
  }

  async getInstitutionById(id: string) {
    // Null until the catalog loads (and after clear() or a failed fetch).
    return (this.dataPluginStoreService.theInstitutionList.theInstitutionViews() ?? []).find(
      (institution) => institution.id === id,
    );
  }

  async getFilterInstitutionAccountById(institutionId: string, institutionAccountId: string) {
    const institution = await this.getInstitutionById(institutionId);
    return await this.institutionService.filterInstitutionAccountById(
      institutionAccountId,
      institution,
    );
  }

  async getAccountType(account: AccountView) {
    let accountType = account.name;

    if (account?.institutionLink?.institutionId) {
      const id = account.institutionLink.institutionId;
      const institutionalAccount = this.userStoreService.institutions
        .institutionViews()
        .find((i) => {
          return i.id === id && i.availableAccounts.find((a) => a.id === id);
        });
      if (institutionalAccount && institutionalAccount?.name) {
        accountType = institutionalAccount.name;
      }
    }
    return accountType;
  }
}
